module.exports = __webpack_public_path__ + "img/xunzhang.147c84d4.svg";